import request from '@/common/request'

class ItemClienteService {
  getAll(params) {
    return request.get('/itens-cliente', { params })
  }

  addItemVoRelationship({ itensClienteIds, itemVoId }) {
    return request.post(`/itens-cliente/vincular/`, {
      itensClienteIds,
      itemVoId
    })
  }

  copiarTributacao({ itensClienteIds, itemVoId }) {
    return request.post(`/itens-cliente/copiar-tributacao/`, {
      itensClienteIds,
      itemVoId
    })
  }

  removeItemVoRelationship(itemClienteId, itemVoId) {
    return request.delete(`/itens-cliente/${itemClienteId}/itens-vo/${itemVoId}/desvincular`)
  }

  getAllItensVinculados(params) {
    return request.get(`/itens-cliente-vo`, { params })
  }

  buscarItensClienteNoLixo() {
    return request.get('/itens-cliente/lixos')
  }

  colocarNoLixo(itensClienteIds, motivoLixo) {
    return request.put('/itens-cliente/lixos', {
      itensClienteIds,
      motivoLixo
    })
  }

  tirarDoLixo(itensClienteIds) {
    return request.delete('/itens-cliente/lixos', {
      params: {
        itensClienteIds: itensClienteIds
      }
    })
  }
}

export default new ItemClienteService()
